import { useState } from "react";

import {
  Theme,
  Button,
} from "@mui/material";
import { createStyles, makeStyles } from '@mui/styles';
import { getRequestPDF } from "../../utils/GetRequest";
import {
  GetApp,
  RotateLeft,
 } from '@mui/icons-material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    cellChanged:{
      fontWeight: "bolder",
      backgroundColor: theme.palette.highlightRow.main,
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    button: {
      marginLeft: theme.spacing(2),
    },
    cell:{},
    cards:{},
  })
);

export default function ButtonDownloadPDF(props:{salesOrg:string,requestNum:number,requestStatus:string,fileName?:string}) {
  const classes = useStyles();
  const salesOrg = props.salesOrg
  const requestNum = props.requestNum
  const requestStatus = props.requestStatus
  const [downloadingFile, setDownloadingFile] = useState<boolean>(false);

  const fileName = props.fileName || `vp_rcnf_${requestNum}.pdf`

  const NO_DOWNLOAD = ['VP_AS_IS','VP_DRAFT','VP_QUEUE','VP_REJECT']
  if (NO_DOWNLOAD.findIndex(s=>s===requestStatus) >= 0){
    return (<></>)
  }

  return (
        <Button
          color="primary"
          variant="contained"
          disabled={downloadingFile}
          className={classes.button}
          onClick={(event) => {
            setDownloadingFile(true);
            getRequestPDF(salesOrg,requestNum)
              .then( reply => {
                //console.log(reply)
                const url = window.URL.createObjectURL( new Blob([reply.data], {type: reply.headers["content-type"]}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
              })
              .finally(()=>{setDownloadingFile(false);})
          }
        }
          >{(!downloadingFile)?(<><GetApp/ >Download PDF</>):(<><RotateLeft />Building File</>)}</Button>
  );
}